<template>
    <div class="xeGoalUsageChart heightMAX">
        <div class="kbet-custom-reset heightMAX">
            <div class="rounded kbet-widget-energy heightMAX" :style="{ display: 'block' }">
                <div class="title rounded-top d-flex justify-content-between align-items-center">
                    <span
                        >{{ $t(widget.title) || "건축물에너지효율등급" }}
                        <span style="cursor: pointer" @click="() => $refs.efficiencyGradeModal.show()">
                            <i class="fa fa-question-circle"></i> </span
                    ></span>

                    <div class="d-flex align-items-center">
                        <div class="safari-style-buttons">
                            <label class="safari-button red">
                                <input type="radio" value="card" v-model="selectedView" />
                                <span class="button-dot"></span>
                            </label>
                            <label class="safari-button yellow">
                                <input type="radio" value="pyramid" v-model="selectedView" />
                                <span class="button-dot"></span>
                            </label>
                            <label class="safari-button green">
                                <input type="radio" value="chart" v-model="selectedView" />
                                <span class="button-dot"></span>
                            </label>
                        </div>
                    </div>
                </div>
                <!-- <small class="common-subtitle" style="margin-left: 20px">
                    {{ `단위면적당 1차에너지 소요량 (${rawData?.values?.grade?.unitInfo?.unit} · ${timeLabel})` }}
                </small> -->
                <div
                    class="d-flex flex-column heightMAX energy-usage-area"
                    style="padding: 0px 20px; height: calc(100% - 41px)"
                >
                    <!-- 카드 뷰 -->
                    <div v-if="selectedView === 'card'" style="width: 100%; height: 100%">
                        <xe-energy-efficiency-card
                            :rawData="rawData"
                            :cardHeight="cardHeight"
                            :cardWidth="cardWidth"
                            :widget="widget"
                        />
                    </div>

                    <!-- 피라미드 뷰 -->
                    <div v-if="selectedView === 'pyramid'" class="heightMAX">
                        <xe-energy-efficiency-grade
                            :rawData="rawData"
                            :cardHeight="cardHeight"
                            :cardWidth="cardWidth"
                            :widget="widget"
                        />
                    </div>

                    <!-- 차트 뷰 -->
                    <div v-if="selectedView === 'chart'" style="width: 100%; height: 100%">
                        <energy-grade-chart-panel
                            :title="'건축물 에너지 효율 등급'"
                            :subTitle="'에너지 효율 등급 추이'"
                            chartHeight="100%"
                            :data="rawData.values?.energyGradeTrend"
                            :xAxisLabel="chartLabels"
                            :bottomMargin="50"
                            :leftMargin="10"
                            :rightMargin="2"
                            :showAxisLabel="false"
                            :showTitle="false"
                            :sideMargin="10"
                            :showZeb="false"
                        />
                    </div>
                </div>
            </div>
        </div>
        <b-modal ref="efficiencyGradeModal" hide-footer @hidden="() => $refs.efficiencyGradeModal.hide()">
            <template #modal-header>
                <div class="d-flex justify-content-between align-items-center w-100">
                    <h5 class="mb-0">건축물 에너지 효율 등급 기준</h5>
                    <div class="d-flex justify-content-end" style="font-size: 14px">
                        <span class="setting-icon">
                            <i class="fas fa-times" @click="() => $refs.efficiencyGradeModal.hide()"></i>
                        </span>
                    </div>
                </div>
            </template>
            <template #default>
                <table class="table table-bordered table-striped text-center">
                    <thead class="thead-dark">
                        <tr>
                            <th scope="col">등급</th>
                            <th scope="col">1차 에너지 소요량 (kWh/㎡·yr) 이하</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(grade, index) in energyGrades" :key="`ENERGY-GRADE-${index}`">
                            <td>{{ grade.grade }}</td>
                            <td>{{ grade.maxConsumption }}</td>
                        </tr>
                    </tbody>
                </table>
            </template>
        </b-modal>
        <b-modal
            ref="modalSetting"
            size="lg"
            :title="`${$t('설정')} - ${$t('건축물에너지효율등급')}`"
            body-class="p-t-0 p-b-0"
            hide-footer
            @shown="onSettingModal(true)"
            @hidden="onSettingModal(false)"
        >
            <xe-efficiency-setting :initSetting="widget" @on-modal-cancel="onModalCancel" @on-modal-ok="onModalOK" />
        </b-modal>
    </div>
</template>

<script>
import xeBaseWidget from "@src/views/widget/v1/common/xeBaseWidget.js";
import xeEfficiencySetting from "./setting/xeEfficiencySetting.vue";
import xeEnergyEfficiencyGrade from "./xeEnergyEfficiencyGrade.vue";
import xeEnergyEfficiencyCard from "./xeEnergyEfficiencyCard.vue";
// import EnergyGradeChartPanel from "../../../new/energy-total-status/building-energy-efficiency-analysis/charts/EnergyGradeChartPanel.vue";
import EnergyGradeChartPanel from "../../../views/new/energy-total-status/building-energy-efficiency-analysis/charts/EnergyGradeChartPanel.vue";

export default {
    name: "xeEnergyEfficiency",
    extends: xeBaseWidget,
    props: ["cardHeight", "cardWidth"],
    components: { xeEfficiencySetting, xeEnergyEfficiencyGrade, xeEnergyEfficiencyCard, EnergyGradeChartPanel },
    data() {
        return {
            rawData: null,
            selectedView: "card", // pyramid, chart,card
            energyGrades: [
                { grade: "1+++", maxConsumption: 80 },
                { grade: "1++", maxConsumption: 140 },
                { grade: "1+", maxConsumption: 200 },
                { grade: "1", maxConsumption: 260 },
                { grade: "2", maxConsumption: 320 },
                { grade: "3", maxConsumption: 380 },
                { grade: "4", maxConsumption: 450 },
                { grade: "5", maxConsumption: 520 },
                { grade: "6", maxConsumption: 610 },
                { grade: "7", maxConsumption: 700 },
            ],
            settingModal: false,
        };
    },
    watch: {
        selectedView() {
            this.$emit("change-view", this.selectedView);
        },
    },
    computed: {
        chartLabels() {
            return this.rawData?.values?.regDt || [];
        },
    },

    methods: {
        onSettingModal(flag) {
            this.settingModal = flag;
        },
        applyData(data) {
            this.rawData = data;
        },
        getWidgetConds() {
            // xeGoalUsageChart 등과 동일하게 최소한 빈 배열이 아닌 값을 반환
            return [{ points: [] }];
        },
    },
};
</script>

<style scoped>
.xeGoalUsageChart {
    width: 100%;
}
.kbet-custom-reset {
    width: 100%;
}

.kbet-widget-energy .title i {
    font-size: 16px;
    margin-right: 10px;
}
.common-subtitle {
    font-size: 11px;
}

.safari-style-buttons {
    display: flex;
    gap: 8px;
    align-items: center;
}

.safari-button {
    position: relative;
    width: 16px;
    height: 16px;
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s ease;
    border: 1px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.safari-button:hover {
    transform: scale(1.1);
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"] {
    position: absolute;
    opacity: 0;
    width: 100%;
    height: 100%;
    cursor: pointer;
}

.safari-button.red {
    background: linear-gradient(135deg, #ff5f57 0%, #ff4444 100%);
}

.safari-button.yellow {
    background: linear-gradient(135deg, #ffbd2e 0%, #ffb300 100%);
}

.safari-button.green {
    background: linear-gradient(135deg, #28ca42 0%, #4caf50 100%);
}

.safari-button input[type="radio"]:checked + .button-dot {
    opacity: 1;
}

.button-dot {
    width: 4px;
    height: 4px;
    background-color: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.safari-button input[type="radio"]:checked {
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.3);
}

.safari-button input[type="radio"]:checked + .button-dot {
    opacity: 1;
}
</style>
